import React, { useEffect } from 'react';
import { createChatBotMessage } from 'react-chatbot-kit';
import { useTranslation } from 'react-i18next';
import { Android, CloseCircle } from 'iconsax-react';
import '@/../css/chatBot.css'
import DepartmentChoise from './DepartmentChoise';

const BotAvatar: React.FC = () => {
    return (
        <div style={{ fontSize: '24px', color: '#38b6ff' }}>
            <Android />
        </div>
    );
};

const useBotConfig = (isDarkMode: string, isChatOpen: boolean, setIsChatOpen: (open: boolean) => void) => {
    const { t, i18n } = useTranslation();
    const botName = t('chatbot.botname');

    useEffect(() => {
        const waitForInput = () => {
            const input = document.getElementsByClassName('react-chatbot-kit-chat-input')[0];
            if (input) {
                (input as HTMLElement).style.backgroundColor = isDarkMode === 'dark' ? '#1E1E1E' : '#FFFFFF';
            } else {
                setTimeout(waitForInput, 100);
            }
        };

        if (isChatOpen) {
            waitForInput();
        }
    }, [isDarkMode, isChatOpen]);

    return {
        initialMessages: [
            createChatBotMessage(t('chatbot.welcome', { botName }), { loading: true }),
        ],
        widgets: [
            {
                widgetName: 'departmentChoise',
                widgetFunc: (props: any) => <DepartmentChoise {...props} />,
            },
        ],
        botName,
        customStyles: {
            chatinnercontainer: {
                direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
                textAlign: i18n.language === 'ar' ? 'right' : 'left',
                color: isDarkMode === 'dark' ? '#105182' : '#acb234',
            },
            botMessageBox: {
                direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
                backgroundColor: isDarkMode === 'dark' ? '#0033A0' : '#0033A0',
                color: '#FFFFFF',
            },
            chatButton: {
                backgroundColor: isDarkMode === 'dark' ? '#555' : '#38b6ff',
            },
            userMessageBox: {
                backgroundColor: isDarkMode === 'dark' ? '#2A2A2A' : '#EAEAEA',
                color: isDarkMode === 'dark' ? '#FFF' : '#000',
            },
        },
        customComponents: {
            botAvatar: (props: any) => <BotAvatar {...props} />,
            header: () => (
                <div
                    style={{
                        backgroundColor: isDarkMode === 'dark' ? '#121212' : '#0033A0',
                        color: '#FFF',
                        borderTopRightRadius: '20px',
                        borderTopLeftRadius: '20px',
                        padding: '10px',
                        textAlign: 'center',
                        fontWeight: 'bold',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <span>{botName}</span>
                    <CloseCircle
                        size="24"
                        // color="#FFF"
                        style={{ cursor: 'pointer' }}
                        onClick={() => setIsChatOpen(false)}
                        className='hover:!text-custom-cyan dark:hover:!text-custom-dark-blue'
                    />
                </div>
            ),
        },
    };
};

export default useBotConfig;
